import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'

const isProd = process.env.NODE_ENV === 'production';

// Import SCSS styles.
import './main.scss';

// Vue-bootstrap.
import BootstrapVue from 'bootstrap-vue';
Vue.use(BootstrapVue);

// FontAwesome.
import {
  FontAwesomeIcon,
  FontAwesomeLayers
} from '@fortawesome/vue-fontawesome'
import {
  library
} from '@fortawesome/fontawesome-svg-core'
import {
  faStreetView, faEllipsisV
} from '@fortawesome/free-solid-svg-icons'
import {
  faCircle
} from '@fortawesome/free-solid-svg-icons'
import {
  faVrCardboard
} from '@fortawesome/free-solid-svg-icons'
import {
  faFacebook,
  faInstagram,
  faYoutube
} from '@fortawesome/free-brands-svg-icons'
library.add(faStreetView, faEllipsisV, faCircle, faVrCardboard, faFacebook, faInstagram, faYoutube)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)

// Vue-recaptcha.
import VueRecaptcha from 'vue-recaptcha';
Vue.component('VueRecaptcha', VueRecaptcha);

// Local components.
import EmbedViewer from '@/components/core/EmbedViewer.vue';
Vue.component('embed-viewer', EmbedViewer);

import EmbedViewerRouteView from '@/components/core/EmbedViewerRouteView.vue';
Vue.component('embed-viewer-route-view', EmbedViewerRouteView);

import CopyLink from '@/components/core/CopyLink.vue';
Vue.component('copy-link', CopyLink);

import CopyText from '@/components/core/CopyText.vue';
Vue.component('copy-text', CopyText);

// Multi-language support.
import i18n from '@/i18n';

// Cookies support.
import VueCookies from 'vue-cookies';
Vue.use(VueCookies);

// Vue analytics.
import VueAnalytics from 'vue-analytics';

function generateGuid() {
  var S4 = function () {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  };
  return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
}

const analyticsClientId = (function () {
  let clientId = window.$cookies.get('analytics-client-id');
  if (!clientId) {
    clientId = generateGuid();
    window.$cookies.set("analytics-client-id", clientId, "0");
  }
  return clientId;
})();

Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_ANALYTICS_ID,
  fields: {
    storage: 'none',
    clientId: analyticsClientId,
  },
  debug: {
    enabled: !isProd
  },
  router
});

Vue.config.productionTip = false

function initVue() {
  new Vue({
    router,
    i18n,
    render: h => h(App)
  }).$mount('#app')
}

if (!process.env.VUE_APP_INSIDE_E2E_TEST) {
  initVue();
} else {
  // Make it accessible to Cypress.
  window.initVue = initVue;
}